import {MutationTree} from 'vuex';
import {CustomerDetailsInterface, CustomerStateInterface} from '@/store/modules/customer/types';
import {Vue} from 'vue-property-decorator';

export const mutations: MutationTree<CustomerStateInterface> = {

    /**
     * Set customer details for the current authenticated user.
     */
    customerDetailsLoaded(state: CustomerStateInterface, payload: CustomerDetailsInterface): void {
        Vue.set(state, 'customerDetails', payload);
    },

    /**
     * Remove the current authenticated user details.
     */
    customerDetailsRemoved(state: CustomerStateInterface): void {
        Vue.set(state, 'customerDetails', undefined);
    },
};
